<script>
import {checkInput} from '../functions/logic.js';
import {bafoeg_kinder_alter} from '../functions/kinder.js';
export default {
    mixins: [Laraform],
    data() {
        return {
            schema: {
                Ausbildung: {
                    schema: {
                        kind_vorh: {
                            conditions: [
                                function (){
                                    //console.log(this.el$('Ausbildung.zeitmodell').value);
                                    // Element präsent?
                                    if (!this.el$('Ausbildung.zeitmodell')) {
                                        return false
                                    }else{
                                        if(this.el$('Ausbildung.zeitmodell').value === 'vollzeit'){
                                            // ist vollzeit
                                            return true
                                        }else{
                                            // ist teilzeit -> true bei meister
                                            return this.el$('Ausbildung.art').value === 'meister';

                                        }
                                    }
                                }
                            ]
                        }
                    },
                },
                Einkommen: {
                    schema: {
                        praktikum: {
                            conditions: [
                                function (){
                                    if (!this.el$('Einkommen.art')) { // Einkommen.art nicht aktiv
                                        return false
                                    }else{ // Einkommen.art aktiv + Praktikum anzeigen, wenn ausgewählt
                                        return !!this.el$('Einkommen.art').value.includes(0);
                                    }
                                }
                            ]
                        },
                        nichtselbst: {
                            conditions: [
                                function (){
                                    if (!this.el$('Einkommen.art')) { // Einkommen.art nicht aktiv
                                        return false
                                    }else{ // Einkommen.art aktiv + anzeigen, wenn ausgewählt
                                        return !!this.el$('Einkommen.art').value.includes(1);
                                    }
                                }
                            ]
                        },
                        selbst: {
                            conditions: [
                                function (){
                                    if (!this.el$('Einkommen.art')) { // Einkommen.art nicht aktiv
                                        return false
                                    }else { // Einkommen.art aktiv + selbständiges Einkommen anzeigen, wenn ausgewählt
                                        return !!this.el$('Einkommen.art').value.includes(2);
                                    }
                                }
                            ]
                        },
                        waise: {
                            conditions: [
                                function (){
                                    if (!this.el$('Einkommen.art')) { // Einkommen.art nicht aktiv
                                        return false
                                    }else{ // Einkommen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        return !!this.el$('Einkommen.art').value.includes(3);
                                    }
                                }
                            ]
                        },
                    },
                },
                Vermoegen: {
                    schema: {
                        ue30verm: {
                            conditions: [
                                function (){
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        return !!((
                                                this.el$('Vermoegen.art').value.includes(0) ||
                                                this.el$('Vermoegen.art').value.includes(1) ||
                                                this.el$('Vermoegen.art').value.includes(2) ||
                                                this.el$('Vermoegen.art').value.includes(3) ||
                                                this.el$('Vermoegen.art').value.includes(5)
                                            )
                                            &&
                                            (
                                                this.el$('Ausbildung.art').value === 'student' ||
                                                this.el$('Ausbildung.art').value === 'schueler'
                                            ));

                                    }
                                }
                            ]
                        },
                        grenzemeister: {
                            conditions: [
                                function (){
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        return !!((
                                                this.el$('Vermoegen.art').value.includes(0) ||
                                                this.el$('Vermoegen.art').value.includes(1) ||
                                                this.el$('Vermoegen.art').value.includes(2) ||
                                                this.el$('Vermoegen.art').value.includes(3) ||
                                                this.el$('Vermoegen.art').value.includes(5)
                                            )
                                            &&
                                            (
                                                this.el$('Ausbildung.art').value === 'meister'
                                            ));

                                    }
                                }
                            ]
                        },
                        bargeld: {
                            conditions: [
                                function () {
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        if(this.el$('Vermoegen.art').value.includes(0)){
                                            if(this.el$('Ausbildung.art')){
                                                if(this.el$('Ausbildung.art').value === 'meister'){
                                                    if(this.el$('Vermoegen.grenzemeister')){
                                                        return (this.el$('Vermoegen.grenzemeister').value === 'ja');
                                                    }
                                                }else if(this.el$('Ausbildung.art').value === 'schueler' || this.el$('Ausbildung.art').value === 'student'){
                                                    if(this.el$('Vermoegen.ue30verm')){
                                                        if(this.el$('Vermoegen.ue30verm').value === 'ja'){
                                                            return (this.el$('Vermoegen.grenzebafoeg').value === 'ja');
                                                        }else{
                                                            return (this.el$('Vermoegen.grenzeu30bafoeg').value === 'ja');
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return false
                                }
                            ]
                        },
                        girokonto: {
                            conditions: [
                                function () {
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        if(this.el$('Vermoegen.art').value.includes(1)){
                                            if(this.el$('Ausbildung.art')){
                                                if(this.el$('Ausbildung.art').value === 'meister'){
                                                    if(this.el$('Vermoegen.grenzemeister')){
                                                        return (this.el$('Vermoegen.grenzemeister').value === 'ja');
                                                    }
                                                }else if(this.el$('Ausbildung.art').value === 'schueler' || this.el$('Ausbildung.art').value === 'student'){
                                                    if(this.el$('Vermoegen.ue30verm')){
                                                        if(this.el$('Vermoegen.ue30verm').value === 'ja'){
                                                            return (this.el$('Vermoegen.grenzebafoeg').value === 'ja');
                                                        }else{
                                                            return (this.el$('Vermoegen.grenzeu30bafoeg').value === 'ja');
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return false
                                }
                            ]
                        },
                        bauspar: {
                            conditions: [
                                function () {
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        if(this.el$('Vermoegen.art').value.includes(2)){
                                            if(this.el$('Ausbildung.art')){
                                                if(this.el$('Ausbildung.art').value === 'meister'){
                                                    if(this.el$('Vermoegen.grenzemeister')){
                                                        return (this.el$('Vermoegen.grenzemeister').value === 'ja');
                                                    }
                                                }else if(this.el$('Ausbildung.art').value === 'schueler' || this.el$('Ausbildung.art').value === 'student'){
                                                    if(this.el$('Vermoegen.ue30verm')){
                                                        if(this.el$('Vermoegen.ue30verm').value === 'ja'){
                                                            return (this.el$('Vermoegen.grenzebafoeg').value === 'ja');
                                                        }else{
                                                            return (this.el$('Vermoegen.grenzeu30bafoeg').value === 'ja');
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return false
                                }
                            ]
                        },
                        lebensv: {
                            conditions: [
                                function () {
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        if(this.el$('Vermoegen.art').value.includes(3)){
                                            if(this.el$('Ausbildung.art')){
                                                if(this.el$('Ausbildung.art').value === 'meister'){
                                                    if(this.el$('Vermoegen.grenzemeister')){
                                                        return (this.el$('Vermoegen.grenzemeister').value === 'ja');
                                                    }
                                                }else if(this.el$('Ausbildung.art').value === 'schueler' || this.el$('Ausbildung.art').value === 'student'){
                                                    if(this.el$('Vermoegen.ue30verm')){
                                                        if(this.el$('Vermoegen.ue30verm').value === 'ja'){
                                                            return (this.el$('Vermoegen.grenzebafoeg').value === 'ja');
                                                        }else{
                                                            return (this.el$('Vermoegen.grenzeu30bafoeg').value === 'ja');
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return false
                                }
                            ]
                        },
                        kfz: {
                            conditions: [
                                function () {
                                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                                        return false
                                    }else{ // Vermoegen.art aktiv + Waisenrente anzeigen, wenn ausgewählt
                                        if(this.el$('Vermoegen.art').value.includes(5)){
                                            if(this.el$('Ausbildung.art')){
                                                if(this.el$('Ausbildung.art').value === 'meister'){
                                                    if(this.el$('Vermoegen.grenzemeister')){
                                                        return (this.el$('Vermoegen.grenzemeister').value === 'ja');
                                                    }
                                                }else if(this.el$('Ausbildung.art').value === 'schueler' || this.el$('Ausbildung.art').value === 'student'){
                                                    if(this.el$('Vermoegen.ue30verm')){
                                                        if(this.el$('Vermoegen.ue30verm').value === 'ja'){
                                                            return (this.el$('Vermoegen.grenzebafoeg').value === 'ja');
                                                        }else{
                                                            return (this.el$('Vermoegen.grenzeu30bafoeg').value === 'ja');
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return false
                                }
                            ]
                        },
                    }
                },
                /*Eltern: {
                    schema: {
                        anzGeschwister: {
                            conditions: [
                                function (){
                                    // Element präsent?
                                    if (!this.el$('Eltern.geschwister') || !this.el$('Eltern.elternunabh')) {
                                        return false
                                    }
                                    // wenn nicht elternunabhängig && Geschwister vorhanden
                                    return ((this.el$('Eltern.elternunabh').value === 'nein') && (this.el$('Eltern.geschwister').value === 'ja'));
                                }
                            ],
                        },
                    },
                },*/
            },
            conditions: {
                vollzeit: () => {
                    //console.log(this.el$('Ausbildung.zeitmodell').value)
                    // If element is not rendered yet return false
                    if (!this.el$('Ausbildung.zeitmodell')) {
                        return false
                    }
                    // wenn vollzeit
                    return (this.el$('Ausbildung.zeitmodell').value) === 'vollzeit'
                },
                schueler_hause: () => {
                    //console.log('schueler_hause:')
                    //console.log(this.el$('Ausbildung.ausbildung_vorr').value)
                    if(this.el$('Ausbildung.art').value==='schueler'){
                        if (!this.el$('Ausbildung.ausbildung_vorr')) {
                            //console.log('schuler: true')
                            return true
                        }
                        if(this.el$('Ausbildung.ausbildung_vorr').value === 'ja'){
                            //console.log('schuler: true')
                            return true
                        }else{
                            if (!this.el$('Ausbildung.divschule')) {
                                //console.log('schuler: true')
                                return true
                            }

                            if(this.el$('Ausbildung.divschule').value === 'allg_schule'){
                                if(!this.el$('Ausbildung.beiEltern')){
                                    //console.log('schuler: true')
                                    return true
                                }

                                return this.el$('Ausbildung.beiEltern').value !== 'ja';
                            }else{
                                //console.log('schuler: true')
                                return true
                            }
                        }
                    }else{
                        return true
                    }
                },
                stipendium: () => {
                    //console.log('einkommen stipendium (4):')
                    //console.log(this.el$('Einkommen.art').value)
                    if (!this.el$('Einkommen.art')) {
                        //console.log('einkommen stipendium: true')
                        return true
                    }
                    return !this.el$('Einkommen.art').value.includes(4);
                },
                riester: () => {
                    if (!this.el$('Vermoegen.art')) { // Vermoegen.art nicht aktiv
                        return false
                    }else{ // Vermoegen.art aktiv + Riester anzeigen, wenn ausgewählt
                        return !!this.el$('Vermoegen.art').value.includes(4);
                    }
                },
                elternunabhaengig: () => {
                    //console.log(this.el$('Eltern.elternunabh').value)
                    // If element is not rendered yet return false
                    if (!this.el$('Eltern.elternunabh')) {
                        return false
                    }
                    // wenn nicht elternunabhängig
                    return (this.el$('Eltern.elternunabh').value) === 'ja'
                },
            },
        }
    },
    mounted() {
        this.on('change', () => {
            // Jede Änderung auf Funktion übergeben
            checkInput(this)
        })
        // Alter der Kinder für BAföG Anrechnung setzen
        bafoeg_kinder_alter(this)
    },
}
</script>
